export enum TableColumnTypes {
    Ampel, String, HasDocument, HasActivity, HasPicture, Double, Date, Int, Bool,
    Expand, Custom, EditIcon, Documents, Drag, Checkbox, DeleteIcon, Dropdown, Progress, User,
    Button, SearchIcon, Harvey, CopyIcon, StatusFinished, Picture, ExportIcon, YesNoRadioButtons
}
